import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import { useHomeScope } from '../../hooks/useHomeScope';
import { useConversationsQuery, useMarkConversationRead, useSendMessage } from '../../queries/messages';
import ConversationList from './ConversationList';
import ContactDrawer from './ContactDrawer';
import NewMessageModal from './NewMessageModal';
import ThreadPanel from './ThreadPanel';
import { Card, EmptyThread, MsgLayout } from './styled';

export default function MessagesTab({ activeNumber, onSelectNumber, onBack, canSend, draft, onDraftChange, onTemplatePick, newOpen, onCloseNew }) {
  const { state } = useLocation();
  const { params } = useHomeScope();
  const { data, isLoading } = useConversationsQuery(params);
  const conversations = data?.conversations || [];
  const markRead = useMarkConversationRead();
  const send = useSendMessage();

  const [profileOpen, setProfileOpen] = useState(Boolean(state?.openProfile));

  const active =
    conversations.find((c) => c.contactNumber === activeNumber) ||
    (activeNumber ? { contactNumber: activeNumber, type: 'contact', tags: [] } : null);

  const select = (contactNumber) => {
    onSelectNumber(contactNumber);
    markRead(contactNumber);
  };

  const startConversation = (contactNumber, body) => {
    const open = () => {
      onCloseNew();
      select(contactNumber);
    };
    if (body) send.mutate({ contactNumber, body }, { onSuccess: open });
    else open();
  };

  return (
    <MsgLayout $detail={Boolean(onBack && active)}>
      <ConversationList
        conversations={conversations}
        loading={isLoading}
        activeNumber={activeNumber}
        onSelect={select}
      />

      {active ? (
        <ThreadPanel
          key={active.contactNumber}
          onBack={onBack}
          conversation={active}
          canSend={canSend}
          draft={draft}
          onDraftChange={onDraftChange}
          onTemplatePick={onTemplatePick}
          onProfile={() => setProfileOpen(true)}
        />
      ) : onBack ? null : (
        <Card>
          <EmptyThread>
            <div>
              <FontAwesomeIcon icon={faComments} />
              <div>Select a conversation to view messages</div>
            </div>
          </EmptyThread>
        </Card>
      )}

      <ContactDrawer open={profileOpen} contactNumber={activeNumber} onClose={() => setProfileOpen(false)} />
      {newOpen && (
        <NewMessageModal onClose={onCloseNew} onStart={startConversation} sending={send.isPending} />
      )}
    </MsgLayout>
  );
}
